import React, { Fragment } from "react";
import { Box, Container, Typography, Button, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ps' || i18n.language === 'dr';

  return (
    <Fragment>
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #F8F9FA, #FFFFFF)",
          color: theme.palette.text.primary,
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "60px 20px",
        }}
      >
        <Container maxWidth="sm">
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "3.5rem", md: "6rem" },
              letterSpacing: "3px",
              textTransform: "uppercase",
              color: theme.palette.text.primary,
              marginBottom: "20px",
            }}
          >
            404
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1.4rem", md: "1.8rem" },
              color: theme.palette.text.secondary,
              marginBottom: "20px",
            }}
          >
            {t('notFound.title')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.disabled,
              marginBottom: "30px",
              lineHeight: 1.6,
            }}
          >
            {t('notFound.description')}
          </Typography>
          <Button
            component={Link}
            to="/"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              padding: "14px 36px",
              borderRadius: "50px",
              fontSize: { xs: "1rem", md: "1.2rem" },
              fontWeight: 600,
              textTransform: "uppercase",
              "&:hover": {
                backgroundColor: theme.palette.primary.light,
              },
            }}
          >
            {t('notFound.goHome')}
          </Button>
        </Container>
      </Box>
    </Fragment>
  );
};

export default NotFound;
